'use client';

import { BonusSlideContent } from '@/features/news-managment/styles';
import { BonusItemComponent } from '@/flat-pages/bonuses/ui/bonus-item/BonusItem';

export const BonusItem = ({ bonus, handleClick, locale, updateDate }) => {
  return (
    <BonusSlideContent $type="promo">
      <BonusItemComponent
        bonus={bonus}
        onClickHandler={() => handleClick(bonus)}
        locale={locale}
        updateDate={updateDate}
        isCarousel={true}
      />
    </BonusSlideContent>
  );
};
